import { render, staticRenderFns } from "./insertPromotedApps.vue?vue&type=template&id=660f2600&scoped=true"
import script from "./insertPromotedApps.vue?vue&type=script&lang=js"
export * from "./insertPromotedApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f2600",
  null
  
)

export default component.exports